import {GetSentToastNotificationApiResponse} from '../types';

export type AppSyncAuthHeader = {
  Authorization: string;
  host: string;
};

export type AppSyncStartPayload = {
  data: string;
  extensions: {
    authorization: AppSyncAuthHeader;
  };
};

export type SubscribeToNotificationsApiArg = {
  variant: 'toast' | 'background';
} & GetSentToastNotificationApiResponse;

export type AppSyncDataPayload = {
  data: {
    onSendNotification: {
      id: string;
      tenantId: string;
      userId: string;
      backgroundNotificationId: string | null;
      toastNotificationId: string | null;
    };
  };
};
export interface AppSyncErrorPayload {
  errors: Array<{
    errorType: string;
    message: string;
  }>;
}

export type AppSyncConnectionAckPayload = {
  connectionTimeoutMs: number;
};

export type AppSyncMessage = {
  id: string;
} & (
  | {
      type: 'connection_init';
    }
  | {
      type: 'connection_ack';
      payload: AppSyncConnectionAckPayload;
    }
  | {
      type: 'start';
      payload: AppSyncStartPayload;
    }
  | {
      type: 'data';
      payload: AppSyncDataPayload;
    }
  | {
      type: 'error';
      payload: AppSyncErrorPayload;
    }
  | {
      type: 'connection_error';
      payload: AppSyncErrorPayload;
    }
  | {
      type: 'complete';
    }
  | {
      type: 'ka';
    }
  | {
      type: 'stop';
    }
  | {
      type: 'start_ack';
    }
);
export type AppSyncMessageType = AppSyncMessage['type'];
